import React from "react";
import { Outlet } from "react-router-dom";
import Footer from "../../components/common/Footer";
import Tabs from "../../components/common/Tabs";

const tabs = [
  {
    link: "/leasing/vacancies",
    title: "vacancies",
  },
  {
    link: "/leasing/guest-cards",
    title: "Guest Cards",
  },
  {
    link: "/leasing/rental-applications",
    title: "Rental Applications",
  },
  {
    link: "/leasing/leases",
    title: "Leases",
  },
  {
    link: "/leasing/renewals",
    title: "Renewals",
  },
];

function Leasing() {
  return (
    <div className="page-container">
      <div className="main-container">
        <Tabs tabs={tabs} keepFirstLinkActive={true}/>
        <Outlet />
        {/* Footer  */}
        <Footer />
      </div>
    </div>
  );
}

export default Leasing;
